class CartService {

    constructor($http, $q, SnackbarService) {
        'ngInject';

        this.$http = $http;
        this.$q = $q;
        this.SnackbarService = SnackbarService;

        this.loaded = false;
        this.loading = false;
        this.showAllErrors = false;

        this.loadingInvoiceData = false;
        this.loadedInvoiceDataError = null;
        this.incompleteGUSInvoiceData = false;
        this.availabilities = new Map();

        // Step 1
        this.items = [];
        this.similarProducts = [];
        this.relatedServicesProducts = [];
        this.summary = null;
        this.payments = null;
        this.paymentGroups = null;
        this.shipments = null
        this.shipmentOptions = {
            gls: null,
            paczkomaty: null
        };
        this.payment = '';
        this.orderId = null;
        this.userEmail = null;
        this.userPhone = null;
        this.paymentTransactionId = null;
        this.hasBikeProduct = false;
        this.step = 1;
        this.userLogged = false;

        // Step 2
        this.data = {
            invoice: false,
            invoice_vat_ue: false,
            invoice_natural_person: false,
            comments: '',
            newsletter: false,
            shipmentAddressId: null,
            invoiceAddressId: null,
            acceptTerms: false,
            shipmentAddress: {
                companyName: '',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                street: '',
                houseNumber: '',
                flatNumber: '',
                city: '',
                zipCode: '',
                country: ''
            },
            invoiceAddress: {
                firstName: '',
                lastName: '',
                companyName: '',
                taxNumber: '',
                street: '',
                houseNumber: '',
                flatNumber: '',
                city: '',
                zipCode: '',
                country: 'Polska'
            },
            gusInvoiceData: {
                companyName: null,
                address: null,
                zipCode: null,
                city: null,
                country: null,
                taxNumber: null
            },
            phone: null,
            displayPhoneInput: false
        };

        this.addresses = {
            shipment: [],
            invoice: []
        };

        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.dataValidations = {
            // adres do wysyłki
            shipmentAddressFirstName: () => this.data.shipmentAddress.firstName != '',
            shipmentAddressLastName: () => this.data.shipmentAddress.lastName != '',
            shipmentAddressEmail: () => emailRegex.test(String(this.data.shipmentAddress.email).toLowerCase()),
            shipmentAddressPhone: () => this.data.shipmentAddress.phone.length === 9,
            shipmentAddressStreet: () => (this.summary && !this.summary.shipping_data) || this.data.shipmentAddress.street != '',
            shipmentAddressHouseNumber: () => (this.summary && !this.summary.shipping_data) || this.data.shipmentAddress.houseNumber != '',
            shipmentAddressCity: () => (this.summary && !this.summary.shipping_data) || this.data.shipmentAddress.city != '',
            shipmentAddressZipCode: () => (this.summary && !this.summary.shipping_data) || this.data.shipmentAddress.zipCode != '',

            // faktura VAT EU na firmę
            invoiceAddressCompanyName: () => {
                if (this.data.invoice_vat_ue && this.data.invoiceAddress.companyName == '') {
                    this.dataValidationsMessages.invoiceAddressCompanyName = 'Nazwa firmy jest wymagana';

                    return false;
                }

                return true;
            },

            // faktura VAT na firmę lub faktura VAT EU na firmę lub płatność wymaga podania NIP
            invoiceAddressTaxNumber: () => {
                const taxEmpty = this.data.invoiceAddress.taxNumber == '';

                if (((this.data.invoice || this.data.invoice_vat_ue) && taxEmpty) || (this.summary && this.summary.payment_nip_required && taxEmpty)) {
                    this.dataValidationsMessages.invoiceAddressTaxNumber = this.data.invoice_vat_ue ? 'VAT EU jest wymagany' : 'NIP jest wymagany';

                    return false;
                }

                if (!this.data.invoice && !this.data.invoice_vat_ue && this.summary && !this.summary.payment_nip_required) {
                    return true;
                }

                this.data.invoiceAddress.taxNumber = String(this.data.invoiceAddress.taxNumber).toUpperCase().replace(/[^A-Z0-9]/gm, '');
                let taxNumber = this.data.invoiceAddress.taxNumber;

                // walidacja NIP PL
                if (this.data.invoice || (this.summary && this.summary.payment_nip_required)) {
                    if (taxNumber.length === 10 && parseInt(taxNumber, 10) > 0) {
                        let weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
                        let sum = 0;
                        for (let i = 0; i < 9; i++) {
                            sum += taxNumber[i] * weights[i];
                        }

                        return (sum % 11) === Number(taxNumber[9]);
                    }

                    this.dataValidationsMessages.invoiceAddressTaxNumber = 'Nieprawidłowy NIP';

                    return false;
                }

                // walidacja VAT EU
                if (this.data.invoice_vat_ue) {
                    const isValidEuVat = (vat) => {
                        if (!vat || vat.length < 4) return false;
                        const cc = vat.slice(0, 2); // kod kraju
                        const allowed = ['AT','BE','BG','HR','CY','CZ','DE','DK','EE','EL','GR','ES','FI','FR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK','XI'];
                        if (!allowed.includes(cc)) return false;
                        // firma spoza PL (UE)
                        if (cc === 'PL') return false;

                        const body = vat.slice(2);
                        // 2-12 znaków alfanumerycznych
                        if (!/^[A-Z0-9]{2,12}$/.test(body)) return false;
                        if (/^([A-Z0-9])\1+$/.test(body)) return false;

                        return true;
                    };

                    if (!isValidEuVat(taxNumber)) {
                        this.dataValidationsMessages.invoiceAddressTaxNumber = 'Nieprawidłowy VAT EU';
                        return false;
                    }

                    return true;
                }

                this.dataValidationsMessages.invoiceAddressTaxNumber = 'Nieprawidłowy NIP';

                return false;
            },

            // faktura VAT na osobę fizyczną lub faktura VAT EU na firmę (bez imienia i nazwiska)
            invoiceAddressFirstName: () => !this.data.invoice_natural_person || this.data.invoiceAddress.firstName != '',
            invoiceAddressLastName: () => !this.data.invoice_natural_person || this.data.invoiceAddress.lastName != '',
            invoiceAddressStreet: () => !(this.data.invoice_natural_person || this.data.invoice_vat_ue) || this.data.invoiceAddress.street != '',
            invoiceAddressHouseNumber: () => !(this.data.invoice_natural_person || this.data.invoice_vat_ue) || this.data.invoiceAddress.houseNumber != '',
            invoiceAddressZipCode: () => !(this.data.invoice_natural_person || this.data.invoice_vat_ue) || this.data.invoiceAddress.zipCode != '',
            invoiceAddressCity: () => !(this.data.invoice_natural_person || this.data.invoice_vat_ue) || this.data.invoiceAddress.city != '',
            gusInvoiceData: () => !this.data.invoice || !this.loadedInvoiceDataError,
            gusInvoiceDataCompanyName: () => !this.data.invoice || this.data.gusInvoiceData.companyName.trim(),
            gusInvoiceDataAddress: () => !this.data.invoice || this.data.gusInvoiceData.address.trim(),
            gusInvoiceDataZipCode: () => !this.data.invoice || this.data.gusInvoiceData.zipCode.trim(),
            gusInvoiceDataCity: () => !this.data.invoice || this.data.gusInvoiceData.city.trim(),
            gusInvoiceDataCountry: () => !this.data.invoice || this.data.gusInvoiceData.country.trim()
        };

        this.loggedDataValidations = {
            // adres do wysyłki
            shipmentAddressId: () => this.data.shipmentAddressId,

            // faktura VAT EU na firmę
            invoiceAddressCompanyName: () => {
                if (this.data.invoice_vat_ue && this.data.invoiceAddress.companyName == '') {
                    this.loggedDataValidationsMessages.invoiceAddressCompanyName = 'Nazwa firmy jest wymagana';

                    return false;
                }

                return true;
            },

            // faktura VAT na firmę lub faktura VAT EU na firmę lub płatność wymaga podania NIP
            invoiceAddressTaxNumber: () => {
                const taxEmpty = this.data.invoiceAddress.taxNumber == '';

                if (((this.data.invoice || this.data.invoice_vat_ue) && taxEmpty) || (this.summary && this.summary.payment_nip_required && taxEmpty)) {
                    this.loggedDataValidationsMessages.invoiceAddressTaxNumber = this.data.invoice_vat_ue ? 'VAT EU jest wymagany' : 'NIP jest wymagany';

                    return false;
                }

                if (!this.data.invoice && !this.data.invoice_vat_ue && this.summary && !this.summary.payment_nip_required) {
                    return true;
                }

                this.data.invoiceAddress.taxNumber = String(this.data.invoiceAddress.taxNumber).toUpperCase().replace(/[^A-Z0-9]/gm, '');
                let taxNumber = this.data.invoiceAddress.taxNumber;

                // walidacja NIP PL
                if (this.data.invoice || (this.summary && this.summary.payment_nip_required)) {
                    if (taxNumber.length === 10 && parseInt(taxNumber, 10) > 0) {
                        let weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
                        let sum = 0;
                        for (let i = 0; i < 9; i++) {
                            sum += taxNumber[i] * weights[i];
                        }

                        return (sum % 11) === Number(taxNumber[9]);
                    }

                    this.loggedDataValidationsMessages.invoiceAddressTaxNumber = 'Nieprawidłowy NIP';

                    return false;
                }

                // walidacja VAT EU
                if (this.data.invoice_vat_ue) {
                    const isValidEuVat = (vat) => {
                        if (!vat || vat.length < 4) return false;
                        const cc = vat.slice(0, 2); // kod kraju
                        const allowed = ['AT','BE','BG','HR','CY','CZ','DE','DK','EE','EL','GR','ES','FI','FR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK','XI'];
                        if (!allowed.includes(cc)) return false;
                        // firma spoza PL (UE)
                        if (cc === 'PL') return false;

                        const body = vat.slice(2);
                        // 2-12 znaków alfanumerycznych
                        if (!/^[A-Z0-9]{2,12}$/.test(body)) return false;
                        if (/^([A-Z0-9])\1+$/.test(body)) return false;

                        return true;
                    };

                    if (!isValidEuVat(taxNumber)) {
                        this.loggedDataValidationsMessages.invoiceAddressTaxNumber = 'Nieprawidłowy VAT EU';

                        return false;
                    }

                    return true;
                }

                this.loggedDataValidationsMessages.invoiceAddressTaxNumber = 'Nieprawidłowy NIP';

                return false;
            },

            // faktura VAT na osobę fizyczną lub faktura VAT EU na firmę (bez imienia i nazwiska)
            invoiceAddressFirstName: () => !this.data.invoice_natural_person || this.data.invoiceAddress.firstName != '',
            invoiceAddressLastName: () => !this.data.invoice_natural_person || this.data.invoiceAddress.lastName != '',
            invoiceAddressStreet: () => !(this.data.invoice_natural_person || this.data.invoice_vat_ue) || this.data.invoiceAddress.street != '',
            invoiceAddressHouseNumber: () => !(this.data.invoice_natural_person || this.data.invoice_vat_ue) || this.data.invoiceAddress.houseNumber != '',
            invoiceAddressZipCode: () => !(this.data.invoice_natural_person || this.data.invoice_vat_ue) || this.data.invoiceAddress.zipCode != '',
            invoiceAddressCity: () => !(this.data.invoice_natural_person || this.data.invoice_vat_ue) || this.data.invoiceAddress.city != '',
            gusInvoiceData: () => !this.data.invoice || !this.loadedInvoiceDataError,
            gusInvoiceDataCompanyName: () => !this.data.invoice || this.data.gusInvoiceData.companyName.trim(),
            gusInvoiceDataAddress: () => !this.data.invoice || this.data.gusInvoiceData.address.trim(),
            gusInvoiceDataZipCode: () => !this.data.invoice || this.data.gusInvoiceData.zipCode.trim(),
            gusInvoiceDataCity: () => !this.data.invoice || this.data.gusInvoiceData.city.trim(),
            gusInvoiceDataCountry: () => !this.data.invoice || this.data.gusInvoiceData.country.trim()
        };

        this.dataValidationsMessages = {}
        this.loggedDataValidationsMessages = {}

        this.ingLeaseNowAvailability = null;
    }

    load() {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.get('/ajax/checkout/get-cart-content').then(
            (response) => {
                const data = response.data.data;

                if (data.products) {
                    for (const product of data.products) {
                        product.savedQuantity = product.quantity;
                    }
                }

                this.items = data.products;
                this.summary = data.summary;
                this.similarProducts = data.similar_products;
                this.relatedServicesProducts = data.related_services_products;
                this.loaded = true;
                this.loading = false;

                if (this.summary && this.summary.availabilities) {
                    this.summary.availabilities.forEach(availability => {
                        this.availabilities.set(parseInt(availability.avail_id), availability);
                    });
                }

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });
            },
            (response) => {
                this.loading = false;
                this.loaded = true;

                if (response.status == 404) {
                    this.items = [];
                    this.summary = null;

                    deferred.resolve({
                        items: this.items,
                        summary: null
                    });

                    return;
                }

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    loadPayments() {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.get('/ajax/checkout/get-payments').then(
            (response) => {
                this.loading = false;
                const data = response.data.data;

                this.ingLeaseNowAvailability = null;

                this.payments = data.payments;
                this.paymentGroups = data.paymentGroups;

                Promise.allSettled([this.getIngLeaseNowIsReady(), this.getGooglePayIsReady()]).then(results => {
                    const [ingLeaseResult, googlePayResult] = results;

                    if (ingLeaseResult.status !== 'fulfilled' || !ingLeaseResult.value) {
                        this.payments = this.payments.filter(payment => payment.module !== 'ing_lease_now');
                    }

                    if (googlePayResult.status !== 'fulfilled' || !googlePayResult.value) {
                        this.payments = this.payments.filter(payment => payment.module !== 'googlepay');
                    }

                    deferred.resolve({
                        payments: this.payments,
                        paymentGroups: this.paymentGroups
                    });
                }).catch(err => {
                    this.loading = false;
                    deferred.reject(err);
                });
            },
            (response) => {
                this.loading = false;

                if (response.status != 404)
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    loadShipments() {
        if (!this.summary) return;

        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/get-shipments',
            {
                country: this.summary.country
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    this.shipments = null;

                    deferred.reject(message);

                    return;
                }

                const data = response.data.data;

                this.shipments = data.shipments.map(shipment => {
                    shipment.options = {};
                    shipment.id = parseInt(shipment.id);

                    return shipment;
                });

                deferred.resolve({
                    shipments: this.shipments
                });
            },
            (response) => {
                this.loading = false;

                if (response.status != 404)
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    loadAddresses() {
        const deferred = this.$q.defer();
        this.loading = true;

        let count = 0;

        this.$http.get('/ajax/checkout/get-shipment-addresses').then(
            (response) => {
                count++;
                this.addresses.shipment = response.data.data.addresses;
                this.data.phone = response.data.data.phone;
                this.data.displayPhoneInput = !response.data.data.phone || response.data.data.phone.length !== 9

                if (count < 2) return;

                this.loading = false;
                deferred.resolve(this.addresses);
            },
            (response) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        this.$http.get('/ajax/checkout/get-invoice-addresses').then(
            (response) => {
                count++;
                this.addresses.invoice = response.data.data.addresses;

                if (count < 2) return;

                this.loading = false;
                deferred.resolve(this.addresses);
            },
            (response) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    changeQuantity(item) {
        if (!this.loaded) return;

        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/change-product-quantity',
            {
                productId: item.product_id,
                variantId: item.variant_id || null,
                quantity: item.quantity
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    for (const item of this.items) {
                        item.quantity = item.savedQuantity;
                    }

                    deferred.reject(message);

                    return;
                }

                const data = response.data.data;

                this.items = data.products;

                for (const product of this.items) {
                    product.savedQuantity = product.quantity;
                }

                this.summary = data.summary;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });
            },
            (response) => {
                for (const item of this.items) {
                    item.quantity = item.savedQuantity;
                }

                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    removeItem(item) {
        if (!this.loaded) {
            return;
        }

        const deferred = this.$q.defer();
        this.loading = true;

        const saveCopy = this.items;

        this.items = this.items.filter(cartItem => item != cartItem);

        this.$http.post(
            '/ajax/checkout/delete-product',
            {
                productId: item.product_id,
                variantId: item.variant_id || null
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    this.items = saveCopy;

                    deferred.reject(message);

                    return;
                }

                const message = response.data.message.content;

                const data = response.data.data;

                this.items = data.products;
                this.summary = data.summary;
                this.similarProducts = data.similar_products;
                this.relatedServicesProducts = data.related_services_products;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });

                this.SnackbarService.add(message, 'success', true, 3000);

                if (typeof window.gtag === 'undefined') {
                    return;
                }

                // Fallback to product/variant ID
                let productCode = item.product_id;

                if (item.variant_id) {
                    productCode = item.variant_id;
                }

                if (item.product_code) {
                    productCode = item.product_code;
                }

                console.log(`gtag::event::remove_from_cart -> usunięcie -> ${productCode}`);

                let productPrice = item.price_gros.toString();
                const productName = item.name + (item.variant_id ? ' - ' + item.variant_name : '');
                const productCategoryName = item.category_name;
                const productQuantity = parseInt(item.quantity);

                window.gtag('event', 'remove_from_cart', {
                    currency: 'PLN',
                    value: parseFloat(productPrice.replace(/(\d+),(\d+).*/, '$1.$2')),
                    items: [
                        {
                            item_id: productCode,
                            item_name: productName,
                            item_category: productCategoryName,
                            price: parseFloat(productPrice.replace(/(\d+),(\d+).*/, '$1.$2')),
                            quantity: productQuantity
                        }
                    ]
                });
            },
            (response) => {
                this.items = saveCopy;
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    addDiscountCode(code) {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/discount-code',
            {code}
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    deferred.reject(message);

                    return;
                }

                const data = response.data.data;

                this.items = data.products;
                this.summary = data.summary;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    removeDiscountCode(discountCode) {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/delete-discount-code',
            {
                code: discountCode
            }
        ).then(
            (response) => {
                this.loading = false;

                if (!response.data.data) {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                const data = response.data.data;

                this.items = data.products;
                this.summary = data.summary;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    setPayment(payment) {
        const deferred = this.$q.defer();
        this.loading = true;
        this.summary.payment_id = payment.id;

        this.$http.post(
            '/ajax/checkout/select-payment',
            {
                paymentId: payment.id
            }
        ).then(
            (response) => {
                this.loading = false;

                if (!response.data.data) {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                const data = response.data.data;
                this.summary = data.summary;

                this.fbqAddPaymentInfo(payment);

                deferred.resolve({
                    summary: this.summary
                });

                console.log(`gtag::event::add_payment_info -> wybor metody platnosci`);

                let eventAddPaymentInfoItems = [];
                for (const cartItem of this.items) {
                    eventAddPaymentInfoItems.push({
                        item_id: cartItem.product_code,
                        item_name: cartItem.name + (cartItem.variant_name ? ` - (${cartItem.variant_name})` : ''),
                        price: cartItem.price_gros,
                        quantity: cartItem.quantity
                    });
                }

                if (typeof window.gtag === 'undefined') {
                    return;
                }

                window.gtag('event', 'add_payment_info', {
                    currency: 'PLN',
                    value: this.summary.amount_to_pay, // pełna kwota brutto (z kosztami wysyłki)
                    payment_type: payment.name,
                    items: eventAddPaymentInfoItems
                });
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    setShipment(shipment, options = null) {
        const deferred = this.$q.defer();
        this.loading = true;
        this.summary.shipment_id = shipment.id;

        this.$http.post(
            '/ajax/checkout/select-shipment',
            {
                shipmentId: shipment.id,
                options: options
            }
        ).then(
            (response) => {
                this.loading = false;

                if (!response.data.data) {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                const data = response.data.data;

                this.summary = data.summary;

                if (shipment.module_name == 'paczkomaty') {
                    this.shipmentOptions.paczkomaty = options;
                }

                deferred.resolve({
                    summary: this.summary
                });

                console.log(`gtag::event::add_shipping_info -> wybor metody dostawy`);

                let eventAddShippingInfoItems = [];
                for (const cartItem of this.items) {
                    eventAddShippingInfoItems.push({
                        item_id: cartItem.product_code,
                        item_name: cartItem.name + (cartItem.variant_name ? ` - (${cartItem.variant_name})` : ''),
                        price: cartItem.price_gros,
                        quantity: cartItem.quantity
                    });
                }

                window.gtag('event', 'add_shipping_info', {
                    currency: 'PLN',
                    value: this.summary.amount_to_pay, // pełna kwota brutto (z kosztami wysyłki)
                    shipping_tier: shipment.name,
                    items: eventAddShippingInfoItems
                });
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    setShipmentMergeOrderEmail(merge_order_email) {
        const deferred = this.$q.defer();
        this.loading = true;
        //let mergeOrderEmail = this.summary.merge_order_email;
        let mergeOrderEmail = merge_order_email;

        this.$http.post(
            '/ajax/checkout/select-shipment-merge-order-email',
            {
                mergeOrderEmail: mergeOrderEmail
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data && response.data.message && response.data.message.type == 'error') {
                    this.SnackbarService.add(response.data.message.content, 'error', true, 3000);

                    const data = response.data.data;

                    this.summary = data.summary;

                    deferred.resolve({
                        summary: this.summary
                    });

                    return;
                }

                if (!response.data.data) {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                const data = response.data.data;

                this.summary = data.summary;

                deferred.resolve({
                    summary: this.summary
                });
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    loadInvoiceData() {
        this.data.gusInvoiceData = {
            companyName: null,
            address: null,
            zipCode: null,
            city: null,
            country: null,
            taxNumber: null
        };

        const deferred = this.$q.defer();

        if (!this.data.invoiceAddress.taxNumber) {
            deferred.resolve();
            return deferred.promise;
        }

        this.loadingInvoiceData = true;
        this.loadedInvoiceDataError = null;
        this.incompleteGUSInvoiceData = false;

        this.$http.get(`/ajax/users/getGusReportByTaxId/${this.data.invoiceAddress.taxNumber}`).then(
            (response) => {
                this.loadingInvoiceData = false;

                if (response.data && response.data.message && response.data.message.type == 'error') {
                    this.loadedInvoiceDataError = response.data.message.content;

                    deferred.reject(response.data.message.content);

                    return;
                }

                if (!response.data.data) {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                this.data.gusInvoiceData = response.data.data;

                this.incompleteGUSInvoiceData = !(this.data.gusInvoiceData.companyName.trim()
                    && this.data.gusInvoiceData.address.trim()
                    && this.data.gusInvoiceData.zipCode.trim()
                    && this.data.gusInvoiceData.city.trim()
                    && this.data.gusInvoiceData.country.trim());

                this.data.invoiceAddress.taxNumber = this.data.gusInvoiceData.taxNumber;

                deferred.resolve(this.data.gusInvoiceData);
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    finalizeOrder() {
        if (!this.stepTwoComplete) return;

        const deferred = this.$q.defer();

        let _this = this;

        this.loading = true;

        this.$http.post(
            '/ajax/checkout/set-addresses-and-finalize-order',
            this.data
        ).then(
            (response) => {
                this.loading = false;

                if (response.data && response.data.message && response.data.message.type == 'error') {
                    this.SnackbarService.add(response.data.message.content, 'error', true, 15000);

                    deferred.reject('Błędne dane!');

                    return;
                }

                if (!response.data.data) {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                const orderId = response.data.data.orderId;

                this.orderId = orderId;
                this.payment = response.data.data.payment;
                this.userEmail = response.data.data.userEmail;
                this.userPhone = response.data.data.userPhone;
                this.paymentTransactionId = response.data.data.paymentTransactionId;
                this.hasBikeProduct = response.data.data.hasBikeProduct;

                if (response.data.data.paymentModuleName === 'googlepay') {
                    let script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = 'https://pay.google.com/gp/p/js/pay.js';
                    script.onload = function() {
                        _this.onGooglePayLoaded();
                    };
                    document.body.appendChild(script);
                }

                deferred.resolve({orderId});
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    /* State walidators */

    get stepOneComplete() {
        if (!this.loaded) return false;

        if (this.loading) return false;

        if (!this.summary) return false;

        if (!this.summary.payment_id) return false;

        if (!this.summary.shipment_id) return false;

        if (!this.shipments) return false;

        const shipment = this.shipments.filter(shipment => shipment.id == this.summary.shipment_id)[0];

        if (!shipment) return false;

        if (shipment.module_name && shipment.module_name == 'paczkomaty') {
            if (!this.shipmentOptions) return false;
            if (!this.shipmentOptions.paczkomaty) return false;
            if (!this.shipmentOptions.paczkomaty.selected) return false;
        }

        if (shipment.merge_orders === '1' && !this.summary.merge_order_email) {
            return false;
        }

        return true;
    }

    get isMergeOrderEmail() {
        if (!this.shipments) return false;

        const shipment = this.shipments.filter(shipment => shipment.id == this.summary.shipment_id)[0];

        if (!shipment) return false;

        if (shipment.merge_orders === '1' && this.summary.merge_order_email) {
            return true;
        }

        return false;
    }

    get displayGusInvoiceDataForm() {
        if (!this.data.invoice) {
            return;
        }

        if (this.data.loadingInvoiceData) {
            return;
        }

        if (this.data.loadedInvoiceDataError) {
            return;
        }

        if (!this.data.gusInvoiceData.taxNumber) {
            return;
        }

        return this.incompleteGUSInvoiceData;
    }

    get stepTwoComplete() {
        if (!this.data.acceptTerms) {
            return false;
        }

        if (this.loadingInvoiceData) {
            return false;
        }

        if (this.userLogged) {
            for (const validatorFnName in this.loggedDataValidations) {
                if (!this.loggedDataValidations[validatorFnName]()) {
                    return false;
                }
            }
        } else {
            for (const validatorFnName in this.dataValidations) {
                if (!this.dataValidations[validatorFnName]()) {
                    return false;
                }
            }
        }

        return true;
    }

    get stepTwoValidationErrors() {
        let errors = {};

        if (!this.data.acceptTerms) {
            errors.acceptTerms = true;
        }

        if (this.userLogged) {
            for (const validatorFnName in this.loggedDataValidations) {
                if (!this.loggedDataValidations[validatorFnName]()) {
                    errors[validatorFnName] = true;
                }
            }
        } else {
            for (const validatorFnName in this.dataValidations) {
                if (!this.dataValidations[validatorFnName]()) {
                    errors[validatorFnName] = true;
                }
            }
        }

        return errors;
    }

    get orderFinalized() {
        if (this.orderId) {
            return true;
        }

        return false;
    }

    updateInvoiceSelection(type) {
        if (type === 'invoice' && this.data[type]) {
            this.data.invoice_natural_person = false;
            this.data.invoice_vat_ue = false;
        }

        if (type === 'invoice_vat_ue' && this.data[type]) {
            this.data.invoice_natural_person = false;
            this.data.invoice = false;
        }

        if (type === 'invoice_natural_person' && this.data[type]) {
            this.data.invoice = false;
            this.data.invoice_vat_ue = false;
        }
    }

    getAvailability(avail_id) {
        return this.availabilities.get(parseInt(avail_id));
    }

    getAvailabilityName(avail_id) {
        const availability = this.getAvailability(avail_id);
        return `<span class="availability-${availability.color}">${availability.name}</span>`;
    }

    getDisplayedAvailabilityName(avail_id, displayed_availability) {
        const availability = this.getAvailability(avail_id);
        return `<span class="availability-${availability.color}">${displayed_availability}</span>`;
    }

    getVariantName(cartItem) {
        let variantName = [];

        if (cartItem && cartItem.variant_name && cartItem.variant_name != '') {
            variantName.push(cartItem.variant_name);
        }

        if (cartItem.variantAttributes && cartItem.variantAttributes.length > 0) {
            cartItem.variantAttributes.forEach(variantAttribute => {
                if (parseInt(variantAttribute.attribute_id) !== 14) {
                    return;
                }
                variantName.push('Rozmiar ramy: ' + variantAttribute.value);
            });
        }

        return variantName ? variantName.join(', ') : null;
    }

    getEnhancedConversionData() {
        let enhanced_conversion_data = {};

        if (this.data.shipmentAddressId) {
            const address = this.addresses.shipment.find(address => parseInt(address.id) === parseInt(this.data.shipmentAddressId));
            if (address) {
                enhanced_conversion_data = {
                    email: this.userEmail,
                    phone_number: this.userPhone,
                    address: {
                        city: address.city,
                        country: this.getCountryIsoCode(address.country),
                        first_name: address.first_name,
                        last_name: address.last_name,
                        street: address.address1,
                        postal_code: address.zip
                    }
                }
            }
        } else {
            enhanced_conversion_data = {
                email: this.data.shipmentAddress.email,
                phone_number: this.data.shipmentAddress.phone,
                address: {
                    city: this.data.shipmentAddress.city,
                    country: this.getCountryIsoCode(this.data.shipmentAddress.country),
                    first_name: this.data.shipmentAddress.firstName,
                    last_name: this.data.shipmentAddress.lastName,
                    street: this.data.shipmentAddress.street,
                    postal_code: this.data.shipmentAddress.zipCode
                }
            }
        }

        return enhanced_conversion_data;
    }

    getCountryIsoCode(countryName) {
        for(let isoCode in allCountries) {
            if(allCountries[isoCode] === countryName) {
                return isoCode;
            }
        }

        return '';
    }

    /* ING Lease Now */

    getIngLeaseNowIsReady() {
        return new Promise((resolve, reject) => {
            this.$http.get('/orders/payment/ing_lease_now/check-leasing-availability')
                .then(response => {
                    if (!response.data || !response.data.data) {
                        return reject(new Error('Wystąpił nieoczekiwany błąd!'));
                    }

                    this.ingLeaseNowAvailability = response.data.data;

                    if (response.data.data.availability === true) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
                .catch(() => {
                    reject(new Error('Wystąpił błąd podczas komunikacji z serwerem!'));
                });
        });
    }

    /* Google Pay */

    getGoogleIsReadyToPayRequest() {
        return Object.assign(
            {},
            {
                apiVersion: 2,
                apiVersionMinor: 0
            },
            {
                allowedPaymentMethods: [
                    {
                        type: 'CARD',
                        parameters: {
                            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                            allowedCardNetworks: ['MASTERCARD', 'VISA']
                        }
                    }
                ]
            }
        );
    }

    getGooglePaymentDataRequest(totalPrice) {
        const paymentDataRequest = Object.assign(
            {},
            {
                apiVersion: 2,
                apiVersionMinor: 0
            }
        );
        paymentDataRequest.allowedPaymentMethods = [
            Object.assign(
                {},
                {
                    type: 'CARD',
                    parameters: {
                        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                        allowedCardNetworks: ['MASTERCARD', 'VISA']
                    }
                },
                {
                    tokenizationSpecification: {
                        type: 'PAYMENT_GATEWAY',
                        parameters: {
                            'gateway': 'payu',
                            'gatewayMerchantId': '466990' // @todo: pos_id do zmiany (prod RoweryStylowe.pl: 84165)
                        }
                    }
                }
            )
        ];
        paymentDataRequest.transactionInfo = this.getGoogleTransactionInfo(totalPrice);
        paymentDataRequest.merchantInfo = {
            merchantId: '12345678901234567890', // @todo: do zmiany
            merchantName: 'RoweryStylowe.pl'
        };
    
        return paymentDataRequest;
    }

    getGooglePaymentsClient() {
        return new Promise((resolve, reject) => {
            if (typeof google === 'undefined') {
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://pay.google.com/gp/p/js/pay.js';
                script.onload = function() {
                    try {
                        resolve(new google.payments.api.PaymentsClient({environment: 'TEST'})); // @todo: do zmiany
                    } catch (error) {
                        reject(error);
                    }
                };
                script.onerror = function() {
                    reject(new Error('Failed to load the Google Pay script'));
                };
                document.head.appendChild(script);
            } else {
                try {
                    resolve(new google.payments.api.PaymentsClient({environment: 'TEST'})); // @todo: do zmiany
                } catch (error) {
                    reject(error);
                }
            }
        });
    }

    getGooglePayIsReady() {
        return this.getGooglePaymentsClient()
            .then(paymentsClient => {
                return paymentsClient.isReadyToPay(this.getGoogleIsReadyToPayRequest());
            })
            .then(response => {
                return response.result;
            })
            .catch(err => {
                console.error(err);
                return false;
            });
    }

    onGooglePayLoaded() {
        let _this = this;
    
        this.getGooglePaymentsClient()
            .then(paymentsClient => {
                return paymentsClient.isReadyToPay(this.getGoogleIsReadyToPayRequest());
            })
            .then(response => {
                if (response.result) {
                    _this.addGooglePayButton();
                }
            })
            .catch(err => {
                console.error(err);
            });
    }    

    addGooglePayButton() {
        this.getGooglePaymentsClient()
            .then(paymentsClient => {
                const button = paymentsClient.createButton({
                    buttonLocale: 'pl',
                    onClick: this.onGooglePaymentButtonClicked.bind(this),
                    allowedPaymentMethods: [
                        {
                            type: 'CARD',
                            parameters: {
                                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                allowedCardNetworks: ['MASTERCARD', 'VISA']
                            }
                        }
                    ]
                });
                document.getElementById('google-pay-container').appendChild(button);
            })
            .catch(err => {
                console.error('Error creating Google Pay button:', err);
            });
    }

    getGoogleTransactionInfo(totalPrice) {
        return {
            countryCode: 'PL',
            currencyCode: 'PLN',
            totalPriceStatus: 'FINAL',
            totalPrice: String(totalPrice)
        };
    }

    onGooglePaymentButtonClicked() {
        let orderId = this.orderId;
        let paymentTransactionId = this.paymentTransactionId;
        let totalPrice = this.summary.amount_to_pay;
    
        const paymentDataRequest = this.getGooglePaymentDataRequest(totalPrice);
        paymentDataRequest.transactionInfo = this.getGoogleTransactionInfo(totalPrice);
    
        this.getGooglePaymentsClient()
            .then(paymentsClient => {
                return paymentsClient.loadPaymentData(paymentDataRequest);
            })
            .then(paymentData => {
                this.googlePayProcessPayment(paymentData, orderId, paymentTransactionId);
            })
            .catch(err => {
                console.error(err);
            });
    }

    googlePayProcessPayment(paymentData, orderId, paymentTransactionId) {
        console.log('googlePayProcessPayment');
        console.log(paymentData);

        let paymentToken = paymentData.paymentMethodData.tokenizationData.token;

        const postData = {
            google_auth_code: paymentToken,
            transaction_id: paymentTransactionId
        };

        const deferred = this.$q.defer();

        this.$http.post(
            '/orders/payment/googlepay/verify-googlepay-token/' + orderId,
            postData
        ).then(
            (response) => {
                console.log(response);

                if (!response.data || !response.data.data || !response.data.data.redirect_uri) {
                    this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                    deferred.reject('Wystąpił nieoczekiwany błąd!');

                    return;
                }

                window.location.href = response.data.data.redirect_uri;
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    /* Fbq track events */

    buildFbqCartEventData() {
        const contents = (this.items || []).map(item => ({
            id: String(item.product_code),
            quantity: Number(item.quantity || 1),
            item_price: Number(item.price_gross || 0)
        }));

        const contentIds = contents.map(item => item.id);
        const value = Number(this.summary.value_of_products || 0);
        const numItems = contents.reduce((sum, item) => sum + item.quantity, 0);

        return {
            content_ids: contentIds,
            contents: contents,
            content_type: 'product',
            currency: 'PLN',
            value: value,
            num_items: numItems
        };
    }

    fbqBeginCheckout() {
        if (typeof window.fbq === 'undefined') {
            return;
        }

        window.fbq('track', 'InitiateCheckout', this.buildFbqCartEventData(), {
            eventID: 'initiate_checkout_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
        });
    }

    fbqAddPaymentInfo(payment) {
        if (typeof window.fbq === 'undefined') {
            return;
        }

        const eventData = this.buildFbqCartEventData();
        eventData.payment_method = payment.name || '';
        eventData.value = Number(this.summary.amount_to_pay || eventData.value || 0);

        window.fbq('track', 'AddPaymentInfo', eventData, {
            eventID: 'add_payment_info_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10)
        });
    }
}

export default CartService;
